import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1906">
      <div className="dark" data-id="element-1907">
        <Hero data-id="element-1908" />
      </div>
      <WhyUs data-id="element-1909" />
      <Services data-id="element-1910" />
      <HowItWorks data-id="element-1911" />
      <FAQ data-id="element-1912" />
      <Reviews data-id="element-1913" />
      <CtaBanner data-id="element-1914" />
    </main>;
}